function applyMasks(doNotLoadDatepicker) {
    $(".dateMask").not('.isMasked').inputmask({ alias: "datetime", placeholder: "MM/DD/YYYY", inputFormat: "mm/dd/yyyy", insertMode: false, showMaskOnHover: true }).addClass('isMasked');

    $(".timeMask").not('.isMasked').inputmask({ alias: "datetime", placeholder: "HH:MM xm", inputFormat: "hh:MM tt", insertMode: false, showMaskOnHover: true, hourFormat: 12 }).addClass('isMasked');

    $(".phoneMask").not('.isMasked').inputmask("(999) 999-9999").addClass('isMasked');

    $(".hoursMask").not('.isMasked').inputmask({ alias: "decimal", digits: 2, max: 999.99, inputmode: 'decimal' }).addClass('isMasked');

    $(".feedbackHoursMask").not('.isMasked').inputmask({ alias: "decimal", digits: 2, max: 24.00, min: 0.00, inputmode: 'decimal' }).addClass('isMasked');

    $(".decimalMask").not('.isMasked').inputmask({ alias: "decimal", digits: 2 }).addClass('isMasked');

    $(".numberMask").not('.isMasked').inputmask("integer").addClass('isMasked');

    $(".positiveSmallIntegerMask").not('.isMasked').inputmask({ mask: "9", repeat: 3, greedy: false }).addClass('isMasked');

    $(".positiveIntegerMask").not('.isMasked').inputmask({ alias: "integer", allowMinus: false }).addClass('isMasked');

    $(".volunteerHoursMask").not('.isMasked').inputmask({ alias: "decimal", digits: 2, max: 99999.99 }).addClass('isMasked');

    $(".latitudeMask").not('.isMasked').inputmask({ alias: "decimal", digits: 10, max: 90, min: -90 }).addClass('isMasked');

    $(".longitudeMask").not('.isMasked').inputmask({ alias: "decimal", digits: 11, max: 180, min: -180 }).addClass('isMasked');

    if (doNotLoadDatepicker !== true) {
        if (jQuery().datepicker) {
            $('.datepicker').datepicker({
                autoclose: true
            });
        }
    }
}

$(function () {
    applyMasks();
});